import { MaintenanceModules, MaintenanceSections } from "@/constants/enums";

// Constantes para mejorar legibilidad
const GRANARY_MODULE = MaintenanceModules.Granaria;
const GENERAL_SECTION = MaintenanceSections.General;
const SALES_SECTION = MaintenanceSections.Sales;
const SALES_RELATED_SECTIONS = [MaintenanceSections.SellOrder, MaintenanceSections.CashOnDelivery, MaintenanceSections.FutureContracts] as const;

/**
 * Ordena las secciones priorizando GENERAL primero, luego SALES en granaria, y el resto alfabéticamente.
 */
export const sortSections = (moduleCode: string) => ([a]: [string, boolean], [b]: [string, boolean]) => {
  const aIsGeneral = a === GENERAL_SECTION;
  const bIsGeneral = b === GENERAL_SECTION;

  if (aIsGeneral && !bIsGeneral) return -1;
  if (!aIsGeneral && bIsGeneral) return 1;

  if (moduleCode === GRANARY_MODULE) {
    const aIsSales = a === SALES_SECTION;
    const bIsSales = b === SALES_SECTION;

    if (aIsSales && !bIsSales) return -1;
    if (!aIsSales && bIsSales) return 1;
  }

  return a.localeCompare(b);
};

/**
 * Determina si una sección debe estar deshabilitada.
 */
export const getSectionDisabledState = (
  moduleCode: string,
  sectionCode: string,
  baseDisabled: boolean,
  moduleGateOn: boolean,
  salesSwitchValue: boolean
): boolean => {
  // Lógica de desactivación base (por módulo general)
  let isDisabled = baseDisabled || (moduleGateOn && sectionCode !== GENERAL_SECTION);

  // Lógica específica para granaria: si SALES tiene mantenimiento activado, desactivar secciones relacionadas
  if (moduleCode === GRANARY_MODULE && sectionCode !== GENERAL_SECTION && sectionCode !== SALES_SECTION) {
    const isSalesRelated = SALES_RELATED_SECTIONS.includes(sectionCode as typeof SALES_RELATED_SECTIONS[number]);
    
    if (isSalesRelated && salesSwitchValue === true) {
      isDisabled = true;
    }
  }

  return isDisabled;
};
